import { apiClient } from './client';

export interface APITutorialProgress {
  levelId: string;
  completed: boolean;
  stars: 0 | 1 | 2 | 3;
  attempts: number;
  completedAt?: string;
}

export interface APIChallengeProgress {
  challengeId: string;
  completed: boolean;
  bestScore: number;
  bestTime: number;
  attempts: number;
  completedAt?: string;
}

export interface APIRoomProgress {
  roomId: string;
  completed: boolean;
  bestTime: number;
  puzzlesCompleted: number;
  completedAt?: string;
}

export interface APIUserProgress {
  tutorialProgress: APITutorialProgress[];
  challengeProgress: APIChallengeProgress[];
  escapeRoomProgress: APIRoomProgress[];
}

export interface UpdateTutorialProgressRequest {
  completed: boolean;
  stars?: 0 | 1 | 2 | 3;
  attempts?: number;
}

export interface UpdateChallengeProgressRequest {
  completed: boolean;
  score?: number;
  time?: number;
  attempts?: number;
}

export interface UpdateRoomProgressRequest {
  completed: boolean;
  time?: number;
  puzzlesCompleted?: number;
  attempts?: number;
}

export const progressApi = {
  async getAllProgress(userId: string): Promise<APIUserProgress> {
    return apiClient.get(`/users/${userId}/progress`);
  },

  async updateTutorialProgress(
    userId: string,
    levelId: string,
    progress: UpdateTutorialProgressRequest
  ): Promise<APITutorialProgress> {
    return apiClient.put(`/users/${userId}/progress/tutorial/${levelId}`, progress);
  },

  async updateChallengeProgress(
    userId: string,
    challengeId: string,
    progress: UpdateChallengeProgressRequest
  ): Promise<APIChallengeProgress> {
    return apiClient.put(`/users/${userId}/progress/challenges/${challengeId}`, progress);
  },

  async updateRoomProgress(
    userId: string,
    roomId: string,
    progress: UpdateRoomProgressRequest
  ): Promise<APIRoomProgress> {
    return apiClient.put(`/users/${userId}/progress/escape-rooms/${roomId}`, progress);
  },
};
